export default {
  left: {
    group: '我的分组',
    location: '日程地点',
    description: '日程说明',
    scoreChart: '评分表',
    scoreChartDescription: '评分表说明',
  },
  logout: '退出登录',
  right: {
    interviewerList: '候选人列表',
    average: '平均分',
    max: '最高分',
    min: '最低分',
    searchPlaceholder: '姓名',
    groupScore: '集体评分',
    allStart: '全部开始',
    startInterview: '开始面试',
    startVideo: '开启视频',
    endInterview: '结束面试',
    number: '编号',
    idCard: '身份证号',
    score: '得分',
    averageScore: '平均成绩',
    class: '等级',
    checkedIn: '已签到',
    checkIn: '签到',
    changeScore: '修改成绩',
    setScore: '评分',
  },
  noCheckedInTips: '该组有未签到的候选人',
  noEntryTip: '当前没有可评分的候选人',
  confirm: '确定',
  error401: '登录过期，请重新登录',
  signOutConfirm: '确定退出面试评分系统?',
  signOutCancel: '取消退出',
  status: {
    unsubmitted: '进行中',
    waiting: '未开始',
    interviewing: '进行中',
    complete: '已结束',
    processing: '已结束',
    confirmed: '已结束',
    unconfirmed: '已结束',
  },
  allStartConfirm: ['确认对该安排下所有候选人开始评分？', '确认后，您的组员可以对本安排下所有候选人进行评分'],
  startInterviewConfirm: '您即将开始面试，一旦开始操作将无法撤销，请确认是否继续？',
  startVideoConfirm: '您即将开启视频，开启后才能开始面试，请确认是否继续？',
  endInterviewConfirm: '结束面试后，面试无法恢复，请确认是否继续操作？',
  unsignedInterviewersConfirm: '有评委尚未签字，是否确定结束面试？',
  endInterviewConfirmButtonText: '确认结束',
};
